import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { UserContext } from '../../hoc/User';
import { LocalizationContext } from '../../hoc/Localization';
import Card from '../Card';
import Button from '../Button';
import Link from '../Link';
import styles from './styles.less';

const CardList = ({ data, linkOptions }) => {
  const { t } = React.useContext(LocalizationContext);
  const { user } = React.useContext(UserContext);

  return (
    <div className={styles.container}>
      <Row className={styles.row} type="flex" gutter={20}>
        {data.map((item, index) => (
          <Col lg={8} md={16} sm={18} xs={20} key={item.id || index}>
            <Card data={item} type="course" user={user} reference="path" />
          </Col>
        ))}
      </Row>
      <Button className={styles.otherButton} version="large" type="primary">
        <Link route="search" queryParams={linkOptions}>
          <span>{t('test.result.more.courses.button')}</span>
        </Link>
      </Button>
    </div>
  );
};

CardList.propTypes = {
  data: PropTypes.array,
  linkOptions: PropTypes.object,
};

CardList.defaultProps = {
  data: [],
  linkOptions: {},
};

export default CardList;
